import styled from 'styled-components'

const DEFAULT_PORTAL_ZINDEX = 1000

export const StyledSelectWrapper = styled.div`
  position: relative;
  background-color: #FFFFFF;
  width: ${props => props.width || 'auto'};
`

export const getCustomStyles = ({ portalZindex }) => {
  return ({
    menuPortal: (provided) => ({
      ...provided,
      zIndex: portalZindex || DEFAULT_PORTAL_ZINDEX,
    }),
  })
}
